module.exports = __webpack_public_path__ + "static/media/13_r_dom_83.49_37.22.44401234.png";